import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";
import ProgramTable from '../container/Program/ProgramTable'
// import NewGif from "../components/Gif/NewGif";

// import EmptyOne from '../container/Empty/EmptyOne';

const Program = () => {
  return (
    <React.Fragment>
      <SEO title="Program | ICSI 2023" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Program"
        content="The Conference"
        contentTwo="Program"
        linkage="/"
        />

      <EmptyTwo>
        {/* <div className="entry-content title-center">
          <h2>The information is to be announced. </h2>
        </div> */}
        <div className="entry-content title-center">
        <h3>Program Schedule</h3>

        <ProgramTable/>
        </div>
        
        <div className="space-60"></div>


    {/* <table className="fee">
      <thead>
        <tr>
          <th>Date</th>
          <th>Time</th>
          <th>Event</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>July 14</td>
          <td>13:00-18:00</td>
          <td>Registration</td>
        </tr>
        <tr>
          <td>July 15</td>
          <td>09:00-12:00</td>
          <td>Opening Ceremony, Plenary talks</td>
        </tr>
        <tr>
          <td rowSpan={2}>July 15</td>
          <td>13:20-16:40</td>
          <td>Parallel Sessions & Special sessions</td>
        </tr>
        <tr>
          <td>18:00-</td>
          <td>Award Ceremony & Banquet</td>
        </tr>
        <tr>
          <td>July 16</td>
          <td>09:00-12:00</td>
          <td>Parallel Sessions & Special sessions</td>
        </tr>
        <tr>
          <td rowSpan={2}>July 17-18</td>
          <td>---</td>
          <td>Social Activities after technical sessions</td>
        </tr>
      </tbody>
    </table> */}



        
          <div className="space-40"></div>
          <div className="newfig">

          <h4>Detailed Scheduled Presentations Timetables</h4>
          </div>
          

        <div className="entry-content2">
          <Link
            className="btn btn-primary btn-hover-secondary  mt-s"
            to={process.env.PUBLIC_URL + "/sessions"}
          >
            Sessions
          </Link>


        </div>
      </EmptyTwo>

      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Program;
